import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/contact/get';
import { postToHamsClient, postToHamsClientContact } from 'util/mac/api/contact/post';
import { putToHamsClient, putToHamsClientNonExternal } from 'util/mac/api/contact/put';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { MACCurrentContactData, PartnerEmailTemplateConfig } from '../models';
import { selectSwitchedUser } from '../selectors';

export const getCustomerByEmail = async (
  email: string,
  includeDeactivated: boolean,
  state: State,
) =>
  fetchWithParamValidation(
    ({ userEmail, includeDeactivatedParam }) =>
      getFromHamsClient(`/email/${userEmail}?includeDeactivated=${includeDeactivatedParam}`, state),
    { userEmail: encodeURIComponent(email), includeDeactivatedParam: includeDeactivated },
  );

export const isMemberOfGroup = (groupName: string, state: State) =>
  fetchWithParamValidation(({ group }) => getFromHamsClient(`/isMemberOf/${group}`, state), {
    group: groupName,
  });

export const isEmail = (state: State) => {
  const contactEmail = selectSwitchedUser(state);
  return fetchWithParamValidation(
    ({ userEmail }) => postToHamsClient(`/email/${userEmail}`, state, { email: userEmail }),
    {
      userEmail: encodeURIComponent(contactEmail),
    },
  );
};

export const external = (state: State, data: MACCurrentContactData) => putToHamsClient(state, data);

export const getPartnerDetails = (itemPartnerId: string, state: State) =>
  fetchWithParamValidation(
    ({ partnerId }) => getFromHamsClient(`/organisation/${partnerId}`, state),
    {
      partnerId: itemPartnerId,
    },
  );

export const getContactsForOrganisation = (id: string, state: State) =>
  fetchWithParamValidation(
    ({ partnerId }) => getFromHamsClient(`/organisation/${partnerId}/contacts`, state),
    {
      partnerId: id,
    },
  );

export const getValidateCountryChange = (countryValue: string, state: State) => {
  const contactEmail = selectSwitchedUser(state);
  return fetchWithParamValidation(
    ({ country }) =>
      getFromHamsClient(`/validate/countryChange?email=${contactEmail}&country=${country}`, state),
    {
      country: countryValue,
    },
  );
};

export const postEnableDisableMainContact = (id: string, isEnable: boolean, state: State) =>
  fetchWithParamValidation(
    ({ contactId }) => postToHamsClientContact(`/main/${contactId}?enable=${isEnable}`, state),
    {
      contactId: id,
    },
  );

export const deleteContact = (id: string, state: State) =>
  fetchWithParamValidation(
    ({ contactId }) => putToHamsClientNonExternal(`/${contactId}/detach`, state),
    {
      contactId: id,
    },
  );

export const postAddNewPartnerContact = (contactDetails: string, state: State) =>
  fetchWithParamValidation(
    () => postToHamsClientContact(`/organisation`, state, contactDetails),
    {},
  );

export const getPartnerEmailTemplateConfig = (id: string, state: State) =>
  fetchWithParamValidation(
    ({ partnerId }) =>
      getFromHamsClient(`/organisation/${partnerId}/partnerEmailTemplateConfig`, state),
    {
      partnerId: id,
    },
  );

export const updatePartnerEmailTemplateConfig = (
  id: string,
  templateConfig: PartnerEmailTemplateConfig,
  state: State,
) =>
  fetchWithParamValidation(
    ({ partnerId }) =>
      postToHamsClient(
        `/organisation/${partnerId}/partnerEmailTemplateConfig`,
        state,
        {},
        templateConfig,
      ),
    {
      partnerId: id,
    },
  );

export const validateTaxIdForOrganisationDetails = (orgDetails: any, state: State) =>
  fetchWithParamValidation(
    () => postToHamsClient(`/validate/taxId/organisation`, state, {}, orgDetails),
    {},
  );

export const validateAddressForContactDetails = (contactDetails: any, state: State) =>
  fetchWithParamValidation(
    () => postToHamsClient(`/validate/taas/organisation`, state, {}, contactDetails),
    {},
  );
